import { CommonEnums } from '../../common.enums';
import { CobolConverter_Inst } from './cobalconverter_inst';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';

export class CobolConverter {
    cobolConverter_Inst: CobolConverter_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    dataObject: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.cobolConverter_Inst = new CobolConverter_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.dataObject = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(cobolConverterTmp: CobolConverter): CobolConverter {
        let cobolConverter: CobolConverter = new CobolConverter();
        cobolConverter.copyFrom(cobolConverterTmp);
        return cobolConverter;
    }

    copy(): CobolConverter {
        let cobolConverterTmp: CobolConverter = new CobolConverter();

        cobolConverterTmp.cobolConverter_Inst = this.cobolConverter_Inst.copy();
        cobolConverterTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        cobolConverterTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        cobolConverterTmp.change_Ind = this.change_Ind;
        cobolConverterTmp.error_Cd = this.error_Cd;
        cobolConverterTmp.error_Msg = this.error_Msg;
        cobolConverterTmp.ref_Id = this.ref_Id;
        cobolConverterTmp.ref_Cd = this.ref_Cd;
        cobolConverterTmp.fldr_Id = this.fldr_Id;
        cobolConverterTmp.dataObject = this.dataObject;

        return cobolConverterTmp;
    }

    copyFrom(cobolConverterTmp: CobolConverter): void {
        this.cobolConverter_Inst.copyFrom(cobolConverterTmp.cobolConverter_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, cobolConverterTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, cobolConverterTmp.dxFlow_Obj_Properties);
        this.change_Ind = cobolConverterTmp.change_Ind;
        this.error_Cd = cobolConverterTmp.error_Cd;
        this.error_Msg = cobolConverterTmp.error_Msg;
        this.ref_Cd = cobolConverterTmp.ref_Cd;
        this.ref_Id = cobolConverterTmp.ref_Id;
        this.fldr_Id = cobolConverterTmp.fldr_Id;
        this.dataObject = cobolConverterTmp.dataObject
    }

    compare(cobolConverterTmp: CobolConverter): string {
        let diffString = '';
        diffString =(this.cobolConverter_Inst).compare(cobolConverterTmp.cobolConverter_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, cobolConverterTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, cobolConverterTmp.dxFlow_Obj_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "CobolConverter [cobolConverter_Inst=" + this.cobolConverter_Inst.toString() +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id +
                ", dataObject=" + this.dataObject.toString();
        }

        str += ']';
        return str;
    }
}